import { render, staticRenderFns } from "./MedicationInfo.vue?vue&type=template&id=28b1c86e&scoped=true&"
import script from "./MedicationInfo.vue?vue&type=script&lang=js&"
export * from "./MedicationInfo.vue?vue&type=script&lang=js&"
import style0 from "./MedicationInfo.vue?vue&type=style&index=0&id=28b1c86e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b1c86e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
